import {Reducer} from 'redux';

import {Place} from 'client/models/places/types';
import {PaginationMeta, getDefaultMeta} from 'client/types/common/index';

import types from './types';

type State = {
  clientPlaces: {
    items: Place[];
    meta: PaginationMeta;
  };
};

const initialState: State = {
  clientPlaces: {
    items: [],
    meta: getDefaultMeta(),
  },
};

const reducer: Reducer<State> = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CLIENT_PLACES_SUCCESS:
      return {
        ...state,
        clientPlaces: {
          items: action.payload.places,
          meta: action.payload.meta,
        },
      };

    default:
      return state;
  }
};

export default reducer;
